import { toast } from "react-toastify";

export const isNullOrEmpty = (data) => {
  return data === null || data === undefined || data.toString().trim().length < 1;
};

export const slice = (data, length = 10) => {
  let newData = data;

  if (data?.length > length) {
    newData = data?.slice(0, length) + "...";
  }

  return newData;
};

export const isValidName = (data, length = 3) => {
  return !isNullOrEmpty(data) && data.toString()?.length >= length;
};

export const isEqualLength = (data, length) => {
  return !isNullOrEmpty(data) && data.toString()?.length === length;
};

export const isLengthInBetween = (data, length1, length2) => {
  if (data) {
    return data.toString().length >= length1 && data.toString().length <= length2;
  }
  return false;
};

export function capitalizeFirstLetter(str) {
  if (!str) return "";

  const firstChar = str.charAt(0).toUpperCase();
  const rest = str.slice(1).toLowerCase();

  return firstChar + rest;
}

export function capitalizeWords(str, locale = undefined) {
  return str
    .toLocaleLowerCase(locale)
    .replace(/(^|[\s\-–—'’])([\p{L}\p{M}])/gu, (_, sep, ch) => sep + ch.toLocaleUpperCase(locale));
}

export const extractLatLng = (input) => {
  if (!input || typeof input !== "string") {
    toast.warn("Input must be a non-empty string");
  }

  const [latitude, longitude] = input?.split(",").map((coord) => coord?.trim());

  if (isNaN(latitude) || isNaN(longitude)) {
    toast.warn("Invalid latitude or longitude value");
  }

  return { latitude: parseFloat(latitude), longitude: parseFloat(longitude) };
};

export const removeUnderscores = (str) => {
  if (!str) return "";
  return str.replace(/_/g, " ");
};

export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const isBase64Image = (str) => {
  if (!str || typeof str !== "string") return false;
  return (
    str.startsWith("data:image") ||
    (!str.startsWith("http") && !str.includes("/storage/") && str.length > 500)
  );
};
